import { useEffect, useState } from "react"

export const useSafeWindow = () => {
    const [safeWindow, setSafeWindow] = useState(null)
    useEffect(() => {
        if (typeof window !== "undefined") setSafeWindow(window)
    }, [])
    return safeWindow;
}